import styled from '@emotion/styled';
import { SPACER, MEDIA_QUERIES, GRID } from 'radiance-ui/lib/constants';
import { LOCAL_COLORS } from 'styles/constants';

export const OuterContainer = styled.div<{
  backgroundColor?: string;
  displayContent: boolean;
}>`
  ${({ displayContent }) => !displayContent && 'display: none;'};
  padding: ${SPACER.large};
  background-color: ${({ backgroundColor }) =>
    backgroundColor ?? LOCAL_COLORS.surfaceWhite};
  overflow-x: scroll;
  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }

  ${MEDIA_QUERIES.mdUp} {
    padding: ${SPACER.x5large} ${SPACER.large};
  }
`;

export const GlyphContainer = styled.div`
  margin: auto;
  display: flex;
  justify-content: space-between;
  gap: ${SPACER.large};
  max-width: ${GRID.xlContentMaxWidth};
  margin: auto;
`;
